import { render, staticRenderFns } from "./TwoFASent.vue?vue&type=template&id=140a39e8&scoped=true&"
import script from "./TwoFASent.vue?vue&type=script&lang=js&"
export * from "./TwoFASent.vue?vue&type=script&lang=js&"
import style0 from "./TwoFASent.vue?vue&type=style&index=0&id=140a39e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a39e8",
  null
  
)

export default component.exports